__turbopack_context__.v({
  "container": "_0hzh9q_container",
  "desc": "_0hzh9q_desc",
  "iconWrapper": "_0hzh9q_iconWrapper",
  "root": "_0hzh9q_root",
  "title": "_0hzh9q_title",
  "trigger": "_0hzh9q_trigger",
});
